import React from 'react';
import PropTypes from 'prop-types';

const NoPets = ({ color = '#224251', background = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      d="M6.5 10c0 1.47-.977 2.5-2 2.5-1.023 0-2-1.03-2-2.5s.977-2.5 2-2.5c1.023 0 2 1.03 2 2.5ZM10.5 6c0 1.47-.977 2.5-2 2.5-1.023 0-2-1.03-2-2.5s.977-2.5 2-2.5c1.023 0 2 1.03 2 2.5ZM16.5 6c0 1.47-.977 2.5-2 2.5-1.023 0-2-1.03-2-2.5s.977-2.5 2-2.5c1.023 0 2 1.03 2 2.5ZM20.5 10c0 1.47-.977 2.5-2 2.5-1.023 0-2-1.03-2-2.5s.977-2.5 2-2.5c1.023 0 2 1.03 2 2.5ZM16.133 14.49l.012.015.014.014.224.227c.556.564 1.103 1.117 1.51 1.732.444.672.691 1.373.58 2.175-.244.839-.82 1.61-1.796 1.834-.093.017-.287.016-.623-.017-.274-.027-.6-.07-.973-.12l-.22-.03c-.923-.121-2.079-.264-3.278-.264h-.168c-1.2 0-2.356.145-3.28.268-.066.01-.13.018-.193.026-.385.052-.718.097-.997.124-.34.033-.532.032-.62.014-.98-.223-1.556-.987-1.8-1.833-.107-.798.142-1.497.588-2.168.408-.613.953-1.166 1.51-1.73l.225-.229.013-.013.012-.014c.53-.626 1.004-1.195 1.49-1.78.27-.325.545-.655.836-1.002.425-.499.898-.93 1.424-1.113l.009-.003c.077-.03.153-.05.227-.064h.005c.188-.037.392-.039.644-.039.25 0 .46.001.646.03.072.014.146.035.221.063l.01.003c.528.185 1.01.618 1.422 1.111l.002.002c.527.624.996 1.188 1.48 1.77l.844 1.01Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill={color}
      stroke={background}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoPets.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string
};

export default NoPets;
